import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import UnitContext from "../../context/unit/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import UnitContextProvider from "../../context/unit/provider";
import SearchFilterCard from "../../components/general/filter-card";
import Can from "../../utils/rbac/can";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import UnitTable from "../../components/unit/unit-table";
interface IProps {
  children?: React.ReactNode;
}

const Unit: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(UnitContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("units")}
        subTitle={t("units_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
            <Button
              type="primary"
              onClick={() => {
                navigate(`/units/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_unit")}
            </Button>
          </Can>,
        ]}
      />
      <SearchFilterCard
        formId="unit-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
          const form = document.getElementById("unit-filter");
          if (form) {
            form.dispatchEvent(new Event("reset", { cancelable: true, bubbles: true }));
          }
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        {/* <UserFilter /> */}
      </SearchFilterCard>

      <UnitTable />
    </div>
  );
};

const UnitPage = () => {
  return (
    // ContextProvider
    <UnitContextProvider>
      <Unit />
    </UnitContextProvider>
  );
};
export default UnitPage;
